export default __webpack_public_path__ + "static/media/kuboto-logo.6dbfcdae.jpg";